import type { WindowCapability, WindowSubject, WindowWhere } from '../window'

/** The sidebar's window door accepts JSON values, never a supplied tree. */
export function sandboxWindowCall(
  window: WindowCapability | null,
  surface: string,
  method: string,
  args: unknown[],
): unknown {
  if (surface !== 'sidebar' || !window)
    throw new Error('window commands require a mounted sidebar fill')
  if (method === 'window.read') return window.read()
  if (method === 'window.open') {
    const raw = args[0]
    if (!raw || typeof raw !== 'object')
      throw new Error('window.open needs a subject')
    const subject = raw as Record<string, unknown>
    if (
      (subject.kind !== 'document' && subject.kind !== 'agent') ||
      (subject.id !== null && typeof subject.id !== 'string') ||
      (subject.projectId !== null && typeof subject.projectId !== 'string')
    )
      throw new Error('window.open needs a valid subject')
    const rawWhere = args[1]
    if (rawWhere !== undefined && rawWhere !== null) {
      if (typeof rawWhere !== 'object')
        throw new Error('window.open needs a valid position')
      const where = rawWhere as Record<string, unknown>
      if (
        (where.leafId !== undefined && typeof where.leafId !== 'string') ||
        (where.edge !== undefined &&
          !['left', 'right', 'up', 'down'].includes(String(where.edge)))
      )
        throw new Error('window.open needs a valid position')
    }
    return window.open(
      subject as unknown as WindowSubject,
      (rawWhere ?? undefined) as WindowWhere | undefined,
    )
  }
  const id = args[0]
  if (typeof id !== 'string' || !id) throw new Error(`${method} needs an id`)
  if (method === 'window.close') return window.close(id)
  if (method === 'window.focus') return window.focus(id)
  if (method === 'window.setSpace') return window.setSpace(id)
  throw new Error(`Unknown window command ${method}`)
}
